import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { assessmentApi } from '../../services/assessmentApi';
import { CreateAssessment } from '../../dtos/Assessments/index';
import { assessmentKeys } from './useGetAssessment';

export function useCreateAssessment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateAssessment) => assessmentApi.create(data),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Successfully created assessment');
        queryClient.invalidateQueries({ queryKey: assessmentKeys.all });
      } else {
        toast.error(`Error: ${response.errorMessage || 'Failed to create assessment'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Error: ${error.message || 'Failed to create assessment'}`);
    },
  });
}
